export default __webpack_public_path__ + "static/media/1803_bar_tn.fe9c5729.jpg";